// @flow
import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
	updateApp,
	triggerUpdateApp,
	hideInstallBanner,
	appInstalled,
	hideInstallPrompt,
	triggerAppInstall,
} from '../actions/serviceWorker';
import { setCookie } from '../utils';
import useFirebase from '../hooks/firebase';

const useServiceWorker = () => {
	const serviceWorker = useSelector((state) => state.serviceWorker || {});
	const { updatedApp, triggeredUpdateApp, promptEvent } = serviceWorker;
	const dispatch = useDispatch();
	const [logEvent] = useFirebase();

	const triggerUpdateAppCb = useCallback(() => {
		dispatch(triggerUpdateApp());
	}, [dispatch]);

	const updateAppCb = useCallback(() => {
		dispatch(updateApp());
	}, [dispatch]);

	useEffect(() => {
		if (triggeredUpdateApp && updatedApp) {
			// setCookie('serviceWorker', JSON.stringify({
			//   updatedApp, triggeredUpdateApp: false,
			// }));
			window.location.reload();
		}
	}, [serviceWorker, triggeredUpdateApp, updatedApp]);

	const hideInstallBannerCb = useCallback(() => {
		dispatch(hideInstallBanner());
		setCookie('hideInstallBanner', '1');
	}, [dispatch]);

	const installPWA = useCallback(() => {
		if (promptEvent) {
			dispatch(triggerAppInstall());
			promptEvent.prompt();
			promptEvent.userChoice.then((choice) => {
				if (choice.outcome === 'accepted') {
					dispatch(appInstalled());
					logEvent('install_app');
				} else {
					dispatch(hideInstallPrompt());
					console.log('User dismissed the A2HS prompt', choice);
				}
			});
		}
	}, [dispatch, logEvent, promptEvent]);

	return [serviceWorker, triggerUpdateAppCb, updateAppCb, hideInstallBannerCb, installPWA];
};

export default useServiceWorker;
